tinymce.addI18n("eo", {
    "#": "",
    "Accessibility": "",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Ago",
    "Activity": "Aktiveco",
    "Address": "Adreso",
    "Advanced": "Porspertula",
    "Align": "\u011cisrandigi ",
    "Align center": "Ordigu centren",
    "Align left": "Ordigu maldekstren",
    "Align right": "Ordigu dekstren",
    "Alignment": "\u011cisrandigo",
    "Alignment {0}": "",
    "All": "\u0108io",
    "Alternative description": "",
    "Alternative source": "Alternativa fonto",
    "Alternative source URL": "URLo de alternativa fonto",
    "Anchor": "",
    "Anchor...": "Ankro...",
    "Anchors": "Ankroj",
    "Animals and Nature": "Bestoj kaj naturo",
    "Arrows": "Sagsimboloj",
    "B": "",
    "Background color": "Fona koloro",
    "Background color {0}": "",
    "Black": "Nigra",
    "Block": "Bloko",
    "Block {0}": "",
    "Blockquote": "Mar\u011denigo",
    "Blocks": "Blokoj",
    "Blue": "Blua",
    "Blue component": "",
    "Body": "Korpo",
    "Bold": "Dika",
    "Border": "Bordero",
    "Border color": "Koloro de bordero",
    "Border style": "Stilo de bordero",
    "Border width": "Lar\u011do de bordero",
    "Bottom": "Subo",
    "Browse files": "",
    "Browse for an image": "Rigardi por iu bildo",
    "Browse links": "",
    "Bullet list": "Punkta listo",
    "Cancel": "Nuligi",
    "Caption": "Cita\u0135o",
    "Cell": "\u0108elo",
    "Cell padding": "\u0108elmar\u011denoj",
    "Cell properties": "\u0108elaj ecoj",
    "Cell spacing": "\u0108elspacoj",
    "Cell styles": "",
    "Cell type": "\u0108ela tipo",
    "Center": "Centro",
    "Characters": "Simboloj",
    "Characters (no spaces)": "Simboloj (senspacetaj)",
    "Circle": "Cirklo",
    "Class": "Klaso",
    "Clear formatting": "Forigi formatigon",
    "Close": "Fermi",
    "Code": "Kodo",
    "Code sample...": "Kodospecimeno...",
    "Code view": "",
    "Color Picker": "Kolorelektilo",
    "Color swatch": "Specimenaro de koloroj",
    "Cols": "Kolumnoj",
    "Column": "Kolumno",
    "Column clipboard actions": "",
    "Column group": "Kolumna grupo",
    "Column header": "",
    "Constrain proportions": "Relativigu proporciojn",
    "Copy": "Kopii",
    "Copy column": "",
    "Copy row": "Kopiu vicon",
    "Could not find the specified string.": "Malsukceso trovi la indikitan sinsekvon",
    "Could not load emojis": "",
    "Count": "Nombri",
    "Currency": "Valuto",
    "Current window": "Aktuala fenestro",
    "Custom color": "Propra koloro",
    "Custom...": "Propra...",
    "Cut": "Eltran\u0109i",
    "Cut column": "",
    "Cut row": "Eltran\u0109u vicon",
    "Dark Blue": "Malhelblua",
    "Dark Gray": "Malhela griza",
    "Dark Green": "Malhela verda",
    "Dark Orange": "Malhela oran\u011da",
    "Dark Purple": "Malhelpurpura",
    "Dark Red": "Malhela ru\u011da",
    "Dark Turquoise": "Malhela turkisa",
    "Dark Yellow": "Malhela flava",
    "Dashed": "",
    "Date/time": "Dato/tempo",
    "Decrease indent": "Malpliigu alineon",
    "Default": "Implicite",
    "Delete accordion": "",
    "Delete column": "Forigu kolumnon",
    "Delete row": "Forigu vicon",
    "Delete table": "Forigu tabelon",
    "Dimensions": "Dimensioj",
    "Disc": "Disko",
    "Div": "",
    "Document": "Dokumento",
    "Dotted": "",
    "Double": "",
    "Drop an image here": "\u0134etu iun bildon \u0109i tien",
    "Dropped file type is not supported": "",
    "Edit": "Redakti",
    "Embed": "Enkonstruu",
    "Emojis": "",
    "Emojis...": "",
    "Error": "Eraro",
    "Error: Form submit field collision.": "Eraro: kolizio de kampoj dum sendado de formularo.",
    "Error: No form element found.": "Eraro: elementoj de formularo forestas",
    "Extended Latin": "Etendita la latina",
    "Failed to initialize plugin: {0}": "Pravalorizado de krompogramo {0} malsukcesis",
    "Failed to load plugin url: {0}": "\u015cargado por kroprograma URLo {0} malsukcesis",
    "Failed to load plugin: {0} from url {1}": "\u015cargado de kromprogramo {0} el URLo {1} malsukcesis",
    "Failed to upload image: {0}": "Al\u015dutado de bildo {0} malsukcesis",
    "File": "Dokumento",
    "Find": "Ser\u0109i",
    "Find (if searchreplace plugin activated)": "Ser\u0109i (se ser\u0109a komprogramo estas aktivigita)",
    "Find and Replace": "",
    "Find and replace...": "Ser\u0109i kaj anstata\u016di... ",
    "Find in selection": "",
    "Find whole words only": "Ser\u0109i nur tutan vorton",
    "Flags": "Flagoj",
    "Focus to contextual toolbar": "Enfokusigi al kunteksta ilobreto",
    "Focus to element path": "Enfokusigi al elementvojo",
    "Focus to menubar": "Enfokusigi al menubreto",
    "Focus to toolbar": "Enfokusigi al ilobreto",
    "Font": "Tiparo",
    "Font size {0}": "",
    "Font sizes": "",
    "Font {0}": "",
    "Fonts": "Tiparoj",
    "Food and Drink": "Man\u011da\u0135o kaj trinka\u0135o",
    "Footer": "Suba pa\u011dtitolo",
    "Format": "Aspektigi",
    "Format {0}": "",
    "Formats": "Formatoj",
    "Fullscreen": "Tutekrane",
    "G": "",
    "General": "\u011cenerala",
    "Gray": "Griza",
    "Green": "Verda",
    "Green component": "",
    "Groove": "",
    "Handy Shortcuts": "Komfortaj \u015dparvojoj",
    "Header": "Supera pa\u011dtitolo",
    "Header cell": "Titola \u0109elo",
    "Heading 1": "Titolo 1",
    "Heading 2": "Titolo 2",
    "Heading 3": "Titolo 3",
    "Heading 4": "Titolo 4",
    "Heading 5": "Titolo 5",
    "Heading 6": "Titolo 6",
    "Headings": "Titoloj",
    "Height": "Alto",
    "Help": "Helpo",
    "Hex color code": "",
    "Hidden": "",
    "Horizontal align": "",
    "Horizontal line": "Horizontala linio",
    "Horizontal space": "Horizontala spaco",
    "ID": "",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "",
    "Image is decorative": "",
    "Image list": "Bildlisto",
    "Image title": "Titolo de bildo",
    "Image...": "Bildo...",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": "",
    "Increase indent": "Pliigu alineon",
    "Inline": "Enlinie",
    "Insert": "Enmeti",
    "Insert Template": "",
    "Insert accordion": "",
    "Insert column after": "Enmetu kolumnon poste",
    "Insert column before": "Enmetu kolumnon anta\u016d",
    "Insert date/time": "Enmetu daton/tempon",
    "Insert image": "Enmetu bildon",
    "Insert link (if link plugin activated)": "Enmeti ligilon (se ligila komprogramo estas aktivigita)",
    "Insert row after": "Enmetu vicon poste",
    "Insert row before": "Enmetu vicon anta\u016d",
    "Insert table": "Enmetu tabelon",
    "Insert template...": "Enmeti \u015dablonon...",
    "Insert video": "Enmetu videon",
    "Insert/Edit code sample": "Enmeti/Redakti kodospecimenon",
    "Insert/edit image": "Enmetu/redaktu bildon",
    "Insert/edit link": "Enmetu/redaktu ligilon",
    "Insert/edit media": "Enmeti/redakti a\u016ddovida\u0135on  ",
    "Insert/edit video": "Enmetu/redaktu videon",
    "Inset": "",
    "Invalid hex color code: {0}": "",
    "Invalid input": "",
    "Italic": "Oblikva",
    "Justify": "Ordigu la\u016dflanke",
    "Keyboard Navigation": "Perklavara movi\u011dado",
    "Language": "Lingvo",
    "Learn more...": "Legu aldone...",
    "Left": "Maldekstro",
    "Left to right": "Maldekstro dekstren",
    "Light Blue": "Helblua",
    "Light Gray": "Helgriza",
    "Light Green": "Helverda",
    "Light Purple": "Helpurpura",
    "Light Red": "Helru\u011da",
    "Light Yellow": "Helflava",
    "Line height": "",
    "Link list": "Ligila listo",
    "Link...": "Ligilo...",
    "List Properties": "",
    "List properties...": "",
    "Loading emojis...": "",
    "Loading...": "",
    "Lower Alpha": "Minuskla alfabeta",
    "Lower Greek": "Minuskla greka",
    "Lower Roman": "Minuskla latina",
    "Match case": "Sekvi usklecon",
    "Mathematical": "Matematika",
    "Media poster (Image URL)": "Ligilo al a\u016ddovida\u0135o (URLo de bildo)",
    "Media...": "A\u016ddovida\u0135o...",
    "Medium Blue": "Meza blua",
    "Medium Gray": "Meza griza",
    "Medium Purple": "Meza purpla",
    "Merge cells": "Kunigu \u0109elojn",
    "Middle": "Mezo",
    "Midnight Blue": "Nigroblua",
    "More...": "Pli...",
    "Name": "Nomo",
    "Navy Blue": "Helblua",
    "New document": "Nova dokumento",
    "New window": "Nova fenestro",
    "Next": "Posta",
    "No": "Ne",
    "No alignment": "",
    "No color": "Neniu koloro",
    "Nonbreaking space": "Nerompebla spaceto",
    "None": "Nenio",
    "Numbered list": "Numera listo",
    "OR": "A\u016c",
    "Objects": "Objektoj",
    "Ok": "Bone",
    "Open help dialog": "Malfermi helpan dialogon",
    "Open link": "",
    "Open link in...": "Sekvi ligilon per...",
    "Open popup menu for split buttons": "",
    "Orange": "Oran\u011da",
    "Outset": "",
    "Page break": "Pa\u011da fino",
    "Paragraph": "Alineo",
    "Paste": "Englui",
    "Paste as text": "Engluu kiel teksto",
    "Paste column after": "",
    "Paste column before": "",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Engluado nun okazas en simpla teksta re\u011dimo. La enhavo estos engluate tiel \u011dis anta\u016d vi mal\u015daltos tiun \u0109i opcion.",
    "Paste or type a link": "Engluu a\u016d enigu ligilon",
    "Paste row after": "Engluu vicon poste",
    "Paste row before": "Engluu vicon anta\u016d",
    "Paste your embed code below:": "Engluu vian internan kodon \u0109i-sube:",
    "People": "Homoj",
    "Plugins": "Kromprogramoj",
    "Plugins installed ({0}):": "Kromprogramoj instalitaj ({0}): ",
    "Powered by {0}": "Funkciigita de {0}",
    "Pre": "",
    "Preferences": "Agordoj",
    "Preformatted": "Anta\u016dformatigita",
    "Premium plugins:": "Premiaj kromprogramoj:",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "Provrigardo",
    "Previous": "Anta\u016da",
    "Print": "",
    "Print...": "Presi...",
    "Purple": "Purpura",
    "Quotations": "Cita\u0135oj",
    "R": "",
    "Range 0 to 255": "",
    "Red": "Ru\u011da",
    "Red component": "",
    "Redo": "Refari",
    "Remove": "",
    "Remove color": "Forigi koloron",
    "Remove link": "Forigu ligilon",
    "Replace": "Anstata\u016digi",
    "Replace all": "Anstata\u016digi \u0109ion",
    "Replace with": "Anstata\u016digi per",
    "Resize": "\u015can\u011du grandecon",
    "Restore last draft": "Restarigu lastan malneton",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "",
    "Rich Text Area. Press ALT-0 for help.": "Ri\u0109teksta loko. Premu fulmoklavon ALT-0 por helpo.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Ri\u0109teksta Areo. Premu ALT-F9 por menuo. Premu ALT-F10 por menuejo. Premu ALT-0 por helpo",
    "Ridge": "",
    "Right": "Dekstro",
    "Right to left": "Dekstro maldekstren",
    "Row": "Vico",
    "Row clipboard actions": "",
    "Row group": "Vica grupo",
    "Row header": "",
    "Row properties": "Vicaj ecoj",
    "Row type": "Vica tipo",
    "Rows": "Vicoj",
    "Save": "Konservi",
    "Save (if save plugin activated)": "Konservi (se konserva komprogramo estas aktivigita)",
    "Scope": "Aplikregiono",
    "Search": "Ser\u0109i",
    "Select all": "Elekti \u0109ion",
    "Select...": "Elektu...",
    "Selection": "Elekto",
    "Shortcut": "\u015cparvojo",
    "Show blocks": "Montru blokojn",
    "Show caption": "Montri apudskribon",
    "Show invisible characters": "Montru nevideblajn signojn",
    "Size": "Grando",
    "Solid": "",
    "Source": "Fonto",
    "Source code": "Fonta kodo",
    "Special Character": "",
    "Special character...": "Speciala signo...",
    "Split cell": "Disdividu \u0109elon",
    "Square": "Kvadrato",
    "Start list at number": "",
    "Strikethrough": "Trastreki",
    "Style": "Stilo",
    "Subscript": "Malsuperskribi",
    "Superscript": "Superskribi",
    "Switch to or from fullscreen mode": "Tra\u015dan\u011di tutekranan re\u011dimon",
    "Symbols": "Simboloj",
    "System Font": "Sistema tiparo",
    "Table": "Tabelo",
    "Table caption": "",
    "Table properties": "Tabelaj ecoj",
    "Table styles": "",
    "Template": "\u015cablono",
    "Templates": "\u015cablonoj",
    "Text": "Teksto",
    "Text color": "Teksta koloro",
    "Text color {0}": "",
    "Text to display": "Montrata teksto",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "La enmetita URLo \u015dajnas esti retadreso. \u0108u vi deziras aldoni prefikson mailto:?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "La enmetita URLo \u015dajnas esti ekstera ligilo. \u0108u vi deziras aldoni nepran prefikson http://?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "",
    "Title": "Titolo",
    "To open the popup, press Shift+Enter": "Por aperigi \u015dprucfenestron premu fulmoklavon Shift+Enter ",
    "Toggle accordion": "",
    "Tools": "Iloj",
    "Top": "Supro",
    "Travel and Places": "Voja\u011doj kaj lokoj",
    "Turquoise": "Turkisa",
    "Underline": "Substreki",
    "Undo": "Malfari",
    "Upload": "Al\u015duti",
    "Uploading image": "",
    "Upper Alpha": "Majuskla alfabeta",
    "Upper Roman": "Majuskla latina",
    "Url": "URL-o",
    "User Defined": "Propre difinita ",
    "Valid": "Valida",
    "Version": "Versio",
    "Vertical align": "",
    "Vertical space": "Vertikala spaco",
    "View": "Vidi",
    "Visual aids": "Videblaj helpiloj",
    "Warn": "Averto",
    "White": "Blanka",
    "Width": "Lar\u011do",
    "Word count": "Vortnombro ",
    "Words": "Vortoj",
    "Words: {0}": "Vortoj: {0}",
    "Yellow": "Flava",
    "Yes": "Jes",
    "You are using {0}": "Vi uzas {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Vi havas nekonservitajn \u015dan\u011dojn, \u0109u vi certe deziras eliri?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Via retumilo ne subtenas rektan aliron al bufro. Bonvolu antata\u016de uzi klavarajn kombinojn Ctrl+X/C/V.",
    "alignment": "niveleco",
    "austral sign": "signo de argentina a\u016dstralo",
    "cedi sign": "signo de ganaa cedio",
    "colon sign": "dupunkto",
    "cruzeiro sign": "signo de brazila kruzero",
    "currency sign": "valutsigno",
    "dollar sign": "signo de usona dolaro",
    "dong sign": "signo de vjetnama dongo",
    "drachma sign": "signo de greka dra\u0125mo",
    "euro-currency sign": "signo de e\u016dro",
    "example": "ekzemplo",
    "formatting": "tekstaran\u011do",
    "french franc sign": "signo de francia franko",
    "german penny symbol": "signo de pfenigo",
    "guarani sign": "signo de paragvaja gvaranio",
    "history": "historio",
    "hryvnia sign": "signo de ukrainia hrivno",
    "indentation": "krommar\u011deno",
    "indian rupee sign": "signo de barata rupio",
    "kip sign": "signo de laosa kipo",
    "lira sign": "signo de itala liro",
    "livre tournois sign": "signo de pundo de Turo",
    "manat sign": "signo de azerbaj\u011dana manato",
    "mill sign": "signo de milono de baza monunuo",
    "naira sign": "signo de ni\u011deria najro",
    "new sheqel sign": "signo de israela siklo",
    "nordic mark sign": "signo de marko",
    "peseta sign": "signo de hispana peseto",
    "peso sign": "signo de peso",
    "ruble sign": "signo de rusia rublo",
    "rupee sign": "signo de rupio",
    "spesmilo sign": "signo de spesmilo",
    "styles": "stilo",
    "tenge sign": "signo de kaza\u0125a tengo",
    "tugrik sign": "signo de mongola tugriko",
    "turkish lira sign": "signo de turka liro",
    "won sign": "signo de koreia \u016dono",
    "yen character": "signo de japana eno",
    "yen/yuan character variant one": "alia varianto de signo de eno/juano",
    "yuan character": "signo de \u0109ina renminbio",
    "yuan character, in hong kong and taiwan": "signo de juano, Hongkongo kaj Tajvano",
    "{0} characters": "{0} signojn",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} vortoj"
});